// WHY (#1393, #2584): CONTAINER drafts require a free-text PICKUP (origin)
// address and SIMPLE drafts may optionally carry one. Lives as its own
// component so both branches share the same controlled-input and cap.
//
// @aiPurpose Edit the SIMPLE/CONTAINER `pickupAddress` slot on the draft
//   scratchpad.
// @aiInvariant SIMPLE may leave the address empty; only the CONTAINER
//   completeness gate requires a non-empty value on send.

import { useTranslation } from 'react-i18next';
import { Textarea } from '../../../ui/index.js';
import { useRequestsStore } from '../store.js';
import type { DraftScratchpad } from '../types.js';

export const PICKUP_ADDRESS_MAX = 2000;

export function PickupAddressField({ d }: { d: DraftScratchpad }) {
  const { t } = useTranslation(['requests']);
  const patchHeader = useRequestsStore((s) => s.patchDraftHeader);
  return (
    <div data-testid="pickup-address-field">
      <Textarea
        ariaLabel={t('requests:draft.pickupAddress.label')}
        value={d.pickupAddress ?? ''}
        onChange={(value) => {
          if (value.length === 0) {
            patchHeader({ pickupAddress: null });
            return;
          }
          // WHY (#1393): cap at the wire-side `max(2000)` mirror so a
          //   paste cannot overflow before save lands a 4xx.
          const next =
            value.length > PICKUP_ADDRESS_MAX ? value.slice(0, PICKUP_ADDRESS_MAX) : value;
          patchHeader({ pickupAddress: next });
        }}
        placeholder={t('requests:draft.pickupAddress.placeholder')}
        rows={3}
      />
    </div>
  );
}
